<template>
    <div ref="menu" class="or-admin-menu flex-column column-hor-center">
        <div class="menu-section flex-column">
            <p class="title">Страницы</p>
            <div class="buttons">
                <div class="button flex-row" v-for="button in pages" 
                    :key="button.text">
                    <p :class="[ 'hover-pointer', 'hover-yellow', {'button-active': button.page === selected_page}]"
                    :style="`color: ${!loaded[button.page] ? '#a77373' : null}`" 
                    @click="select_page(button.page)">
                    {{button.text}}
                    </p>
                    <div class="warn" v-show="$parent.unsaved.includes(button.page)"></div>
                </div>
            </div>
        </div>
        <div class="menu-section flex-column">
            <p class="title">Сущности</p>
            <div class="buttons">
                <div class="button flex-row" v-for="button in entities" 
                    :key="button.text">
                    <p :class="[ 'hover-pointer', 'hover-yellow', {'button-active': button.page === selected_page}]" 
                    :style="`color: ${!loaded[button.page] ? '#a77373' : null}`" 
                    @click="select_page(button.page)">
                    {{button.text}}
                    </p>
                    <div class="warn" v-show="$parent.unsaved.includes(button.page)"></div>
                </div>
            </div>
        </div>
        <div class="menu-section flex-column">
            <p class="title">Данные</p>
            <div class="buttons">
                <div class="button flex-row" v-for="button in info" 
                    :key="button.text">
                    <p :class="[ 'hover-pointer', 'hover-yellow', {'button-active': button.page === selected_page}]" 
                    :style="`color: ${!loaded[button.page] ? '#a77373' : null}`" 
                    @click="select_page(button.page)">
                    {{button.text}}
                    </p>
                    <div class="warn" v-show="$parent.unsaved.includes(button.page)"></div>
                </div>
            </div>
        </div>
        <p class="close hover-pointer" @click="hide_menu">Свернуть</p>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
export default {
    props: {
        loaded: Boolean,
    },
    data() {
        return {
            selected_page: 'main',
            pages: [
                {
                    text: 'Главная страница', 
                    page: 'main'
                },
                {
                    text: 'О компании', 
                    page: 'about'
                },
                {
                    text: 'Продукция', 
                    page: 'production'
                },
                {
                    text: 'Покупателям', 
                    page: 'buyers'
                },
                {
                    text: 'Новости', 
                    page: 'news'
                },
                {
                    text: 'Контакты', 
                    page: 'contacts'
                }
            ],
            entities: [
                {
                    text: 'Изделия',
                    page: 'products',
                }
            ],
            info: [
                {
                    text: 'Контактные данные',
                    page: 'info'
                }
            ]
        }
    },
    methods: {
        ...mapActions({changeIsMenuHidden: 'changeIsMenuHidden'}),
        select_page(page) {
            this.selected_page = page;
            this.$emit('selected', {page});
        },
        hide_menu() {
            this.$parent.show_menu_button = true;
            this.$refs.menu.style.width = '0px';
            this.$parent.expand_content();
            this.changeIsMenuHidden({value: true})
        }
    }
}
</script>

<style scoped>
    .or-admin-menu {
        width: 256px;
        background-color: #1e1e1e;
        overflow: hidden;
        transition-duration: 150ms;
    }
    .menu-section {
        position: relative;
        padding-top: 20px;
        padding-left: 46px;
        box-sizing: border-box;
        width: 100%;
        font-size: 14px;
        line-height: 16px;
        text-align: left;
        border-bottom: #EBEFF2 2px solid;
    }
    .title {
        width: 160px;
        color: white;
        font-weight: bold;
        margin-bottom: 20px;
    }
    .buttons {
        width: 160px;
    }
    .button {
        width: 100%;
        color: white;
        margin-bottom: 15px;
    }
    .button:last-of-type {
        margin-bottom: 30px;
    }
    .button-active {
        color: #EBB932;
    }
    .warn {
        position: absolute;
        right: 30px;
        width: 5px;
        height: 5px;
        border-radius: 5px;
        background-color: #b3544a;
        margin-left: 5px;
        margin-top: 5px;
    }
    .close {
        color: white;
        text-align: left;
        font-size: 14px;
        line-height: 16px;
        width: 65%;
        margin-top: 50px;
    }
</style>